import * as THREE from "three";

export default function light(scene){
    const ambientLight = new THREE.AmbientLight(0xffffff, 2.5);
    scene.add(ambientLight);

    // const keyLight = new THREE.DirectionalLight(0xffffff, 2.0);
    // keyLight.position.set(20, 20, 7.5);
    // keyLight.castShadow = true;
    //
    // keyLight.shadow.mapSize.width = 4096;
    // keyLight.shadow.mapSize.height = 4096;
    // keyLight.shadow.camera.near = 0.5;
    // keyLight.shadow.camera.far = 50;
    // keyLight.shadow.bias = -0.001;
    //
    // scene.add(keyLight);
    //
    // const fillLight = new THREE.DirectionalLight(0xffffff, 0.6);
    // fillLight.position.set(-5, 3, -4);
    // scene.add(fillLight);
}